import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProgressionContext } from '../contexts/progression_context';
import { useUserContext } from '../contexts/user_context';

import box from '../assets/box.png';

import './season_component.css';

export const Season: FC = () => {
    const { xp } = useUserContext();
    const { seasons } = useProgressionContext();
    const navigate = useNavigate();

    const on_click = () => navigate('/season-pass');

    const current_season = useMemo(() => seasons[0], [seasons]);

    const pass_points = useMemo(() => {
        if (!current_season) return [];
        const { pass } = current_season;
        if (!pass?.tiers || pass.tiers.length === 0) return [];

        const max_xp_list = pass.tiers
            .map((tier, index) => ({ max_xp: tier.max_xp, index }))
            .filter((x) => x !== undefined && x !== null)
            .sort((a, b) => a.max_xp - b.max_xp);

        if (max_xp_list.length === 0) return [];

        let start_index = max_xp_list.findIndex((x) => xp < x.max_xp);
        if (start_index === -1 || start_index + 2 >= max_xp_list.length) {
            start_index = Math.max(0, max_xp_list.length - 3);
        } else {
            start_index = Math.max(0, start_index - (start_index % 3));
        }

        return max_xp_list.slice(start_index, start_index + 3);
    }, [current_season, xp]);

    const current_tiers = useMemo(() => {
        if (pass_points.length < 3) return [];

        return pass_points.map((tier, index) => {
            let prev_xp = pass_points[index - 1]?.max_xp || 0;
            let progress = Math.min(100, ((xp - prev_xp) / (tier.max_xp - prev_xp)) * 100);
            return {
                tier_xp: tier.max_xp,
                progress: Math.min(Math.max(0, Math.round(progress)), 100),
                index: tier.index,
            };
        });
    }, [pass_points, xp]);

    const current_tier = useMemo(() => {
        if (!current_tiers.length) return 1;
        const completed = current_tiers.filter(({ progress }) => progress === 100);
        return Math.max(1, (current_tiers[completed.length - 1]?.index ?? 0) + 1);
    }, [current_tiers]);

    return current_season ? (
        <>
            <div className='season-card' onClick={on_click}>
                <div className='fog fog-left violet'>
                    <div className='name-wrap'>
                        <span className='name'>{current_season.name}</span>
                        <span className='tier-points'>Your tier: {current_tier}</span>
                    </div>
                    <div className='pass-wrap'>
                        {current_tiers.map(({ tier_xp, progress, index }) => (
                            <div
                                className='pass-tier-item'
                                key={index}
                                data-earned={Number(progress === 100)}
                                data-first-tier={Number(index === 0)}
                                data-last-tier={Number(index === current_season.pass.tiers?.length - 1)}
                            >
                                <span>{tier_xp}</span>
                                <div className='progress-wrap'>
                                    <div className='progress' style={{ width: `${progress}%` }}></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <img alt='' src={box} />
            </div>
        </>
    ) : null;
};
